import { getProductSkusByPlanId } from '../common/product/utils';

const ANALYTICS_DEFAULT_PLAN = 'analytics_basic_2000';
const FEEDBACK_DEFAULT_PLAN = 'feedback_basic_20';

/**
 * Takes the plan ID of a site and returns whether or not a bundle discount is applicable.
 *
 * A bundle discount is applicable if the composite plan being bought contains paid plans from both the Analytics
 * and the Feedback products.
 *
 * The plan ID can be either a regular one (`basic_2000_cc`) or
 * a concatenated one (`analytics_basic_2000;feedback_basic_20`)
 */
export const hasBundleDiscount = (planId: string | undefined): boolean => {
  if (!planId) {
    return false;
  }

  const productSkus = getProductSkusByPlanId(planId);

  if (productSkus.length <= 1) {
    return false;
  }

  const [analyticsSku, feedbackSku] = productSkus;

  return analyticsSku !== ANALYTICS_DEFAULT_PLAN && feedbackSku !== FEEDBACK_DEFAULT_PLAN;
};
